import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceText',
    standalone: false
})
export class ReplaceText implements PipeTransform {

  transform(value: string, ...args: any[]) {
    if (value) {
      return value.replace("{{BaseLine}}", args[0]);
    }
    
    return null; // or return a default value
  }
}
